import React from "react";
import { ACTIONS } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { FullScreenButton } from "@cadenza/ui";

const FullScreenButtonI18n = (props) => {
  const { STRINGS = {} } = useLanguageContext() || {};
  const fullLabel = STRINGS[ACTIONS.SHOW_FULLSCREEN] || "Full Screen";
  const exitLabel = STRINGS[ACTIONS.EXIT_FULLSCREEN] || "Exit Full Screen";
  return (
    <FullScreenButton fullLabel={fullLabel} exitLabel={exitLabel} {...props} />
  );
};

export default FullScreenButtonI18n;
